<template>
  <footer class="footer">
    <footertop-u4 v-if="isU4Theme"/>
    <footertop v-else/>
    <footerbottom/>
  </footer>
</template>

<script>
import Helper from '../../helpers/helper.service'
import footertop from '../../components/footertop.vue'
import footertopU4 from '../../components/footertop-u4.vue'
import footerbottom from '../../components/footerbottom.vue'

export default {
  components: {
    footertop,
    footertopU4,
    footerbottom,
  },
  computed: {
    isU4Theme() {
      return Helper.getTheme() === 'u4'
    },
  },
}
</script>
